import React, { useEffect, useState } from 'react';
import { baseUrl } from '../../Contants';

// Full-screen maintenance screen shown when the API reports a brownout (503
// { status: 'maintenance' }). Covers the case a customer already has the app
// open — a fresh navigation gets the server's outage.html instead. Triggered by
// the 'srp-maintenance' window event dispatched from the axios interceptor.
export default function MaintenanceOverlay() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener('srp-maintenance', show);
    return () => window.removeEventListener('srp-maintenance', show);
  }, []);

  // Poll for recovery instead of blindly reloading: a hard reload while the
  // server is mid-restart (nothing listening) would replace this page with the
  // browser's error page. So we keep the overlay up and probe /version every 5s
  // — only reload once the server answers healthy (200). While it's down
  // (fetch throws) or still browned out (503), we stay put and try again.
  useEffect(() => {
    if (!open) return undefined;
    let stopped = false;
    const probe = () => {
      fetch(`${baseUrl}/api/version`, { cache: 'no-store' })
        .then((res) => {
          if (!stopped && res.ok) window.location.reload();
        })
        .catch(() => {
          /* server not up yet — keep waiting */
        });
    };
    const id = setInterval(probe, 5000);
    return () => {
      stopped = true;
      clearInterval(id);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 2147483647,
        background:
          'radial-gradient(1200px 600px at 50% -10%, #1c3f56 0%, #142e3e 60%)',
        color: '#eaf2f7',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        textAlign: 'center',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      }}
    >
      <div style={{ maxWidth: 520 }}>
        <h1 style={{ color: '#fff', fontSize: 30, margin: '0 0 14px' }}>
          We&rsquo;ll be <span style={{ color: '#28c4fc' }}>right back</span>
        </h1>
        <p
          style={{
            color: '#c6d6df',
            fontSize: 17,
            lineHeight: 1.6,
            margin: '0 auto 10px',
            maxWidth: 460,
          }}
        >
          This site is temporarily unavailable while we finish a maintenance
          update.
        </p>
        <p
          style={{
            color: '#c6d6df',
            fontSize: 17,
            lineHeight: 1.6,
            margin: '0 auto 22px',
            maxWidth: 460,
          }}
        >
          It should be back shortly &mdash; this page will retry automatically.
        </p>
        <button
          onClick={() => window.location.reload()}
          style={{
            background: '#28c4fc',
            color: '#0a1a24',
            border: 'none',
            borderRadius: 6,
            padding: '10px 22px',
            fontSize: 15,
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          Reload now
        </button>
        <div style={{ marginTop: 40, fontWeight: 700, color: '#fff' }}>
          Showroom<span style={{ color: '#ff682c' }}>Pricing</span>
        </div>
      </div>
    </div>
  );
}
